export default __webpack_public_path__ + "static/media/logoMobile.5dbad9e0.png";